import { useAccount } from 'wagmi';
import { useAllUserSchedules, useDeletedSchedules } from '@/features/dca-schedules/hooks/useDcaSchedules';

/**
 * Returns whether the connected wallet is a "new" user (no active and no deleted schedules).
 * When wallet is not connected, isNew is false (we don't hide nav for non-connected users).
 */
export function useIsNewUser() {
  const { address } = useAccount();
  const schedulesQuery = useAllUserSchedules();
  const deletedQuery = useDeletedSchedules(address);

  const isLoading = schedulesQuery.isLoading || deletedQuery.isLoading;
  const hasError = !!schedulesQuery.error || !!deletedQuery.error;

  const activeCount = schedulesQuery.schedules.length;
  const deletedCount = deletedQuery.data?.length ?? 0;

  // Not connected → not "new" (show full nav)
  // Connected + loading → undetermined, treat as not new to avoid flash
  // Connected + API error → treat as not new (fail-open; keep navigation available)
  // Connected + loaded + 0 active + 0 deleted → new
  const isNew = !!address && !isLoading && !hasError && activeCount === 0 && deletedCount === 0;

  return { isNew, isLoading };
}
